"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemToRecentlytViewedPropertyRequest = exports.itemToSavePropertyRequest = exports.SortOrderTypes = exports.SavedPropertySortTypes = exports.SavedPropertyTypes = void 0;
var SavedPropertyTypes;
(function (SavedPropertyTypes) {
    SavedPropertyTypes[SavedPropertyTypes["Favorite"] = 1] = "Favorite";
    SavedPropertyTypes[SavedPropertyTypes["RecentlyViewed"] = 2] = "RecentlyViewed";
})(SavedPropertyTypes = exports.SavedPropertyTypes || (exports.SavedPropertyTypes = {}));
var SavedPropertySortTypes;
(function (SavedPropertySortTypes) {
    SavedPropertySortTypes[SavedPropertySortTypes["CreatedDate"] = 1] = "CreatedDate";
    SavedPropertySortTypes[SavedPropertySortTypes["UpdatedDate"] = 2] = "UpdatedDate";
    SavedPropertySortTypes[SavedPropertySortTypes["Name"] = 3] = "Name";
})(SavedPropertySortTypes = exports.SavedPropertySortTypes || (exports.SavedPropertySortTypes = {}));
var SortOrderTypes;
(function (SortOrderTypes) {
    SortOrderTypes[SortOrderTypes["Ascending"] = 1] = "Ascending";
    SortOrderTypes[SortOrderTypes["Descending"] = 2] = "Descending";
})(SortOrderTypes = exports.SortOrderTypes || (exports.SortOrderTypes = {}));
exports.itemToSavePropertyRequest = function (item) {
    var requestBody = {
        savedPropertyType: SavedPropertyTypes.Favorite,
        propertyListingId: Number(item.referenceId),
        createdDate: (item.createdDate ? new Date(item.createdDate) : new Date()).toISOString(),
    };
    if (item.salePrice)
        requestBody.currentSalePrice = Number(item.salePrice);
    if (item.leasePrice)
        requestBody.currentLeasePrice = Number(item.leasePrice);
    return requestBody;
};
exports.itemToRecentlytViewedPropertyRequest = function (item) {
    var requestBody = {
        savedPropertyType: SavedPropertyTypes.RecentlyViewed,
        propertyListingId: Number(item.referenceId),
        createdDate: (item.createdDate ? new Date(item.createdDate) : new Date()).toISOString(),
    };
    if (item.salePrice)
        requestBody.currentSalePrice = Number(item.salePrice);
    if (item.leasePrice)
        requestBody.currentLeasePrice = Number(item.leasePrice);
    return requestBody;
};
